// src/UI/Text/Heading.jsx
import React from "react";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

/**
 * Heading — компонент для заголовков.
 * Можно настроить кастомные стили (шрифт, размер, вес и т.д.).
 */
const StyledHeading = styled(Typography)(({ theme }) => ({
  fontFamily: "Inter, sans-serif", 
  fontWeight: 700,
  fontSize: 24,
  lineHeight: "29px",
  letterSpacing: 0,
  color: theme.palette.TextAndIcon.primaryBlackBlueEnabled,
}));

export default function Heading({ children, variant = "h5", ...props }) {
  return (
    <StyledHeading variant={variant} {...props}>
      {children}
    </StyledHeading>
  );
}
